<template>
    <div>
        <div class="lg:hidden">
            <select-input
                v-model="selectedPackageId"
                name="packages"
                :options="packagesAsOptions"
                :placeholder="lang('Välj tillvalspaket','Select add-on package')"
                @input="changePackage"
            />
        </div>
        <div class="mb-2xl -mx-sm hidden lg:flex">
            <div
                v-for="tvPackage in packages"
                :key="tvPackage.id"
                class="w-full mx-sm"
            >
                <a
                    v-tooltip.top="tvPackage.name"
                    class="product-tab py-xl"
                    :class="{ 'is-active': activePackage === tvPackage }"
                    @click="togglePackage(tvPackage)"
                >
                    <tv-simple-package-summary
                        :tv-package="tvPackage"
                    />
                    <div>
                        <show-hide-button
                            :active="activePackage === tvPackage"
                            button-classes="btn btn-sm is-primary lg:mt-lg"
                        />
                    </div>
                </a>
            </div>
        </div>
        <div id="active-base-package" />
        <div
            v-if="activePackage"
            class="card"
        >
            <div class="lg:hidden mb-xl">
                <tv-simple-package-summary
                    :tv-package="activePackage"
                />
            </div>

            <h3 class="mb-2xl">{{ activePackage.name }}</h3>

            <p v-if="activePackage.description" class="mb-2xl">
                {{ activePackage.description }}
            </p>

            <tv-channel-list :tv-package="activePackage" />

            <div class="flex flex-wrap items-center md:mt-3xl">
                <div v-if="activePackage.can_be_added_to_cart || cannotDeliver" class="button-group md:ml-auto">
                    <add-to-cart-button
                        extra-class="btn-lg"
                        :article-class="activePackage.article_class"
                        :article-id="activePackage.article_id"
                        :disabled="cannotDeliver"
                    >
                        {{ btnOrderText }}
                    </add-to-cart-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import TvSimplePackageSummary from './Partials/TvSimplePackageSummary';
    import TvChannelList from './Partials/TvChannelList';

    export default {
        components: {
            TvSimplePackageSummary,
            TvChannelList,
        },
        props: {
            packages: {
                type: Array,
                required: true,
            },
            packagesAsOptions: {
                type: Array,
                required: true,
            },
            cannotDeliver: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                activePackage: null,
                selectedPackageId: this.activePackage ? this.activePackage.id : '',
            };
        },
        computed: {
            btnOrderText() {
                return this.translation('services_blocks_btn_add_to_cart');
            },
        },
        methods: {
            changePackage(value) {
                this.activePackage = this.packages.find(tvPackage => tvPackage.id === value);
                this.scrollToActivePackage();
            },
            togglePackage(tvPackage) {
                if (this.activePackage === tvPackage) {
                    this.activePackage = null;
                    return;
                }

                this.activePackage = tvPackage;
                this.scrollToActivePackage();
            },
            scrollToActivePackage() {
                const offset = window.utils.breakpoint('md') ? -230 : -84;
                window.utils.scrollIt('#active-base-package', 'smooth', null, offset);
            },
        },
    };
</script>
